import React from "react";
import Navbarsticky from "./NavbarSticky";
import Footer from "./Footer";
import { Container, Row, Col, Button, Badge, Card, Dropdown } from "react-bootstrap";

import img1 from "../assets/img/img-2.png";
import img2 from "../assets/img/img-4.jpg";
import img4 from "../assets/img/img-1.png";
import img3 from "../assets/img/img-3.jpg";

import review from "../assets/img/reviewimg1.png"


export default function Dashboard() {


  const bookingHistory = [
    {
      id: 1,
      bookingId: "AMH1234",
      title: "Andaman Holiday Package",
      date: "12 Jan 2025",
      price: "₹ 24,999",
      status: "Confirmed",
      image:
        img1,
    },
    {
      id: 2,
      bookingId: "AMH1235",
      title: "Havelock Island Tour",
      date: "15 Jan 2025",
      price: "₹ 18,500",
      status: "Cancelled",
      image:
        img2,
    },
    {
      id: 3,
      bookingId: "AMH1236",
      title: "Neil Island Trip",
      date: "20 Jan 2025",
      price: "₹ 12,999",
      status: "Confirmed",
      image:
        img3,
    },
    {
      id: 4,
      bookingId: "AMH1237",
      title: "Scuba Diving Package",
      date: "25 Jan 2025",
      price: "₹ 6,999",
      status: "Cancelled",
      image:
        img4,
    },
    {
      id: 5,
      bookingId: "AMH1238",
      title: "Glass Bottom Boat Ride",
      date: "28 Jan 2025",
      price: "₹ 3,499",
      status: "Confirmed",
      image:
        img1,
    },
    {
      id: 6,
      bookingId: "AMH1239",
      title: "Port Blair City Tour",
      date: "02 Feb 2025",
      price: "₹ 4,999",
      status: "Confirmed",
      image:
        img2,
    },
    {
      id: 7,
      bookingId: "AMH1240",
      title: "Luxury Cruise Package",
      date: "05 Feb 2025",
      price: "₹ 32,000",
      status: "Confirmed",
      image:
        img3,
    },
    {
      id: 8,
      bookingId: "AMH1235",
      title: "Havelock Island Tour",
      date: "15 Jan 2025",
      price: "₹ 18,500",
      status: "Confirmed",
      image: img4,
    },
    {
      id: 9,
      bookingId: "AMH1242",
      title: "Romantic Couple Package",
      date: "14 Feb 2025",
      price: "₹ 27,999",
      status: "Cancelled",
      image:
        img1,
    },
    {
      id: 10,
      bookingId: "AMH1243",
      title: "Family Tour Package",
      date: "18 Feb 2025",
      price: "₹ 21,500",
      status: "Confirmed",
      image:
        img2,
    },
  ];





  return (
    <>
      <Navbarsticky />

      {/* Top background */}
      <div className="usrdash-bg"></div>

      <Container className="usrdash-wrapper">

        {/* ===== profile card ===== */}
        <div className="usrdash-profilecard">
          {/* Cover */}
          <div className="usrdash-cover d-flex justify-content-center align-items-center">
            {/* Title */}
            <h2 className="usrdash-title">User Dashboard</h2>
          </div>

          <div className="usrdash-profilebody">
            <Row className="align-items-center">
              <Col md={8} sm={12} className="usrdash-left">
                <img
                  src={review}
                  alt="User"
                  className="usrdash-avatar"
                />

                <div className="usrdash-info">
                  <h3>User Name</h3>
                  <p className="text-muted mb-1">user@gmail.com</p>
                  <p className="text-muted mb-0">+91 98765 43210</p>
                </div>
              </Col>

              <Col md={4} sm={12} className="usrdash-actions">
                <Button className="usrdash-btnedit">
                  Edit Profile
                </Button>
                <Button className="usrdash-btnLogout">
                  Logout
                </Button>
              </Col>
            </Row>

            {/* Tags */}
            <div className="usrdash-tags">
              <Badge bg="light" style={{ color: "black" }}>Bookings</Badge>
              <Badge bg="light" style={{ color: "black" }}>Travel</Badge>
              <Badge bg="light" style={{ color: "black" }}>Premium User</Badge>
            </div>
          </div>
        </div>

        {/* ===== Menu bar ===== */}
        <div className="usrdash-menubar">
          <h5>Booking History</h5>

          <Dropdown>
            <Dropdown.Toggle className="usrdash-dropdownbtn">
              My Account
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item>My Profile</Dropdown.Item>
              <Dropdown.Item>Booking History</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>

        {/* ===== booking history ===== */}
        <Row className="mt-4 g-4">
          {bookingHistory.map((item) => (
            <Col md={6} lg={4} key={item.id}>
              <Card className="usrdash-bookingcard">
                {/* Image */}
                <div className="usrDash-imgwrap">
                  <Card.Img
                    variant="top"
                    src={item.image}
                    className="usrdash-img"
                  />
                  <span
                    className={`usrdash-status ${item.status === "Confirmed" ? "confirmed" : "cancelled"
                      }`}
                  >
                    {item.status}
                  </span>

                </div>

                <Card.Body>
                  <h6 className="usrdash-bookingtitle">
                    {item.title}
                  </h6>

                  <p className="usrdash-text">
                    Booking ID: <strong>#{item.bookingId}</strong>
                  </p>
                  <p className="usrdash-text">
                    Date: {item.date}
                  </p>

                  <div className="usrdash-pricerow">
                    <span className="usrdash-price">
                      {item.price}
                    </span>
                    <Button size="sm" className="usrdash-viewbtn">
                      View
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

      </Container>

      <Footer />
    </>
  );
}
